// 系统管理
export default {
  path: '/Operate',
  component: () => import('views/Layout.vue'),
  children: [
    {
      path: 'OrderManager',
      name: 'OrderManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '充电订单',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "OrderManager"*/ 'views/operate/orderManager'),
      },
    },
    {
      path: 'UserManager',
      name: 'UserManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '用户管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "UserManager"*/ 'views/operate/userManager'),
      },
    },
    {
      path: 'UserRoleManager',
      name: 'UserRoleManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '黑白名单管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "UserRoleManager"*/ 'views/operate/userRoleManager'),
      },
    },
    {
      path: 'RecordManager',
      name: 'RecordManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '消费记录',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "RecordManager"*/ 'views/operate/recordManager'),
      },
    },
    {
      path: 'RateManager',
      name: 'RateManager',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '费率管理',
        keepAlive: true,
        defaultComponent: () => import(/*webpackChunkName: "RateManager"*/ 'views/operate/rateManager'),
      },
    },
    {
      path: 'EnergyEfficiency',
      name: 'EnergyEfficiency',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '节能效率测量',
        keepAlive: true,
        defaultComponent: () => import('views/operate/energyEfficiency.vue'),
      },
    },
    {
      path: 'ElectricityBill',
      name: 'ElectricityBill',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '电费账单',
        keepAlive: true,
        defaultComponent: () => import('views/operate/electricityBill.vue'),
      },
    },
    {
      path: '/:pathMatch(.*)',
      component: () => import('@/views/webview.vue'),
      meta: {
        _meauname: '运营管理404',
        defaultComponent: () => import('views/404'),
      },
    },
  ],
}
